import {openModal} from "src/utilities/utilityFunctions";
import React,{useRef} from "react";
import store from 'src/store';
import {gsap,Back,Elastic,Power4} from "gsap";
import SmallScreenMenuPage from "src/components/TDP/HomePage/SmallScreenMenuPage";

const hideMeMods= [
    "components/TDP/TDPHome"
];
const burgerHolderStyle = {
    width:50,height:50,borderRadius:25,backgroundColor:"#0080ff",marginLeft:0,
    position:"absolute",zIndex:1,cursor:"pointer",boxShadow:"0px 8px 18px 0px rgba(0,27,53,0.56)"
};
const burgerStyle ={
        color:"#0080ff",width:50,height:50,borderRadius:26,border:"solid #0080ff 6px",fontWeight:"bold",display: "flex",
        background:'#ffffff',alignItems: "center", justifyContent: "center"
    };

const SmallScreenHomeButton = () => {
    let stateData = store.getState();
    const menuModalRef = useRef();

    const blackout = () =>{
        let buttonArray = gsap.utils.toArray(".mobileFrontScreenButton");
        let angle = 360/buttonArray.length;

        for (let i = 0; i < buttonArray.length; ++i) {
            gsap.set(buttonArray[i], {rotationY:0,x:-1500*Math.cos(angle*(i)),y:1500*Math.sin(angle*(i)),opacity:0});
        }
        gsap.set(menuModalRef.current, {background:'rgba(0,0,0,0.0)'});

        gsap.set(menuModalRef.current, {display:'grid'});
        gsap.to(menuModalRef.current,1.5,{background:'rgba(0,0,0,0.75)'});
        gsap.to(".mobileFrontScreenButton",.64,{stagger:0,opacity:1,x:0,y:0,scale:1,rotationY:0,rotationZ:0,ease:Back.easeOut});
    }
    const killModal = () =>{
    let buttonArray = gsap.utils.toArray(".mobileFrontScreenButton");
    let angle = 360/buttonArray.length;

    for (let i = 0; i < buttonArray.length; ++i) {
        gsap.to(buttonArray[i],.6, {x:-1500*Math.cos(angle*(i)),y:1500*Math.sin(angle*(i)),ease:Back.easeIn});
    }
    gsap.to(menuModalRef.current,.6,{background:'rgba(0,0,0,0)',onComplete:function(){ gsap.set(menuModalRef.current, {display:'none'}) }});
}

    return (
        hideMeMods.indexOf(stateData.appSettings.appMainModuleName) > -1
            ?
            null
            :
            <div>
                <div style={{display:"flex",justifyContent:"center",marginTop:-3,height:50}}>
                    <div id='menuRef' style={burgerHolderStyle} onClick={()=>blackout()}>
                        <div style={burgerStyle} className="burgerStyle">
                            <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" fill="currentColor" className="bi bi-list" viewBox="0 0 16 16">
                              <path fillRule="evenodd" d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"/>
                            </svg>
                        </div>
                    </div>
                </div>

                <div ref={menuModalRef}
                    onClick={()=>killModal()}
                    style={{
                        width:'100vw',
                        height:'100vh',
                        position:'fixed',
                        top:0,
                        left:0,
                        background:'rgba(0,0,0,0.75)',
                        display:'none',
                        placeItems:'center',
                        padding:'1rem',
                        zIndex:1000
                    }}>
                    <SmallScreenMenuPage modalMode={true}/>
                </div>
            </div>
        );
};

export default SmallScreenHomeButton;
// <button onClick={()=>openModal("components/TDP/HomePage/SmallScreenMenuPage")}>Home</button>
